import { TagChipRow } from '@/features/report/Tags';
import type { Tag as TagModel } from '@/models/tag';
import { Tag } from '@/shared/ui/Tag';
import styles from './TagsSection.module.css';

interface TagsSectionProps {
  tags: TagModel[];
}

export default function TagsSection({ tags }: TagsSectionProps) {
  if (tags.length === 0) return null;

  return (
    <TagChipRow className={styles.section}>
      {tags.map((tag) => (
        <Tag
          key={tag.value}
          value={tag.value}
          source={tag.source}
          role="listitem"
        />
      ))}
    </TagChipRow>
  );
}
